<div class="icon-notes-counter-bubble">
    <span class="bubble"
        title="{{title}}"
        (click)="onBubbleClick($event)"
        ><strong><em class="bubble-letter">{{letter}}</em></strong>
    </span>
</div>
